import client from '@/api/client';

export const BATCH_INVITATIONS_START = 'users/invitations/START';
export const BATCH_INVITATIONS_SUCCESS = 'users/invitations/SUCCESS';
export const BATCH_INVITATIONS_FAILURE = 'users/invitations/FAILURE';

/*
 * SÓ O ENVIO EM LOTE, que é o que o formulário de convite ainda faz por aqui.
 *
 * Este módulo era o gerador do `_CRUDL` com o `batch` por cima, e o gerador dava a metade de
 * LISTAGEM: o estado da coleção, os filtros iniciais e as ações de index e delete. Ela saiu
 * junto com a listagem de convites, que passou a ser do embed - lá, quem lista, filtra e
 * apaga é ele, com o próprio request e a própria recarga. Ficou o que sobrou de uso.
 *
 * O `namespaced` era do gerador e agora é escrito: o formulário despacha
 * `userInvitations/batch`.
 */
export default {
  namespaced: true,

  state: {
    batch: {
      error: null,
      loading: false,
      result: {},
    },
  },

  actions: {
    batch({ commit }, payload) {
      commit(BATCH_INVITATIONS_START);

      return new Promise((resolve, reject) => {
        client.post('/user_invitations/batch', payload)
          .then((response) => {
            commit(BATCH_INVITATIONS_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(BATCH_INVITATIONS_FAILURE, error);
            reject(error);
          });
      });
    },
  },

  mutations: {
    [BATCH_INVITATIONS_START](state) {
      state.batch.error = null;
      state.batch.loading = true;
      state.batch.result = {};
    },
    [BATCH_INVITATIONS_SUCCESS](state, response) {
      state.batch.error = null;
      state.batch.loading = false;
      state.batch.result = response.data;
    },
    [BATCH_INVITATIONS_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.batch.error = details;
      state.batch.loading = false;
      state.batch.result = {};
    },
  },
};
